export default {
  // Geral
  'app.name': 'Soulidari',
  'common.save': 'Salvar',
  'common.cancel': 'Cancelar',
  'common.edit': 'Editar',
  'common.delete': 'Excluir',
  'common.search': 'Buscar',
  'common.loading': 'Carregando...',
  'common.success': 'Sucesso!',
  'common.error': 'Erro',
  'common.close': 'Fechar',
  'common.confirm': 'Confirmar',
  'common.back': 'Voltar',
  'common.next': 'Próximo',
  'common.yes': 'Sim',
  'common.no': 'Não',
  
  // Perfil
  'profile.title': 'Meu Perfil',
  'profile.subtitle': 'Gerencie suas informações pessoais',
  'profile.edit': 'Editar Perfil',
  'profile.name': 'Nome',
  'profile.email': 'Email',
  'profile.phone': 'Telefone',
  'profile.password': 'Nova Senha',
  'profile.passwordPlaceholder': '••••••••',
  'profile.passwordHint': 'deixe vazio para manter',
  'profile.language': 'Idioma',
  'profile.languageHelp': 'Escolha o idioma da interface',
  'profile.lastLogin': 'Último Login',
  'profile.saveSuccess': 'Perfil atualizado com sucesso!',
  'profile.languageSuccess': 'Idioma alterado! Recarregando...',
  
  // Layout
 'layout.masterDashboard': 'Dashboard Master',
'layout.companies': 'Empresas',
'layout.allCompanies': 'Todas as Empresas',
'layout.system': 'Sistema',
'layout.systemUsers': 'Usuários do Sistema',
'layout.auditLogs': 'Logs de Auditoria',
'layout.dashboard': 'Dashboard',
'layout.myDashboard': 'Meu Dashboard',
'layout.attendance': 'Atendimento',
'layout.conversations': 'Conversas',
'layout.myConversations': 'Minhas Conversas',
'layout.contacts': 'Contatos',
'layout.tasks': 'Tarefas',
'layout.myTasks': 'Minhas Tarefas',
'layout.chatbot': 'Chatbot',
'layout.visualFunnel': 'Funil Visual',
'layout.crm': 'CRM',
'layout.leads': 'Leads',
'layout.monitoring': 'Monitoramento',
'layout.teamPerformance': 'Desempenho da Equipe',
'layout.appointments': 'Agendamentos',
'layout.biIntegration': 'Integração BI',
'layout.achievements': 'Conquistas',
'layout.myPerformance': 'Meu Desempenho',
'layout.administration': 'Administração',
'layout.users': 'Usuários',
'layout.sectors': 'Setores',
'layout.phoneNumbers': 'Números WhatsApp',
'layout.communication': 'Comunicação',
'layout.templates': 'Templates',
'layout.bulkMessaging': 'Disparos em Massa',
'layout.automations': 'Automações',
'layout.aiAgents': 'Agentes de IA',
'layout.optIn': 'Gestão de Opt-in',
'layout.reports': 'Relatórios',
'layout.businessAccounts': 'Contas Business',
'layout.profile': 'Meu Perfil',
'layout.settings': 'Configurações',
'layout.logout': 'Sair',
'layout.fullControl': 'Controle total do sistema',
'layout.status': 'Status',
'layout.online': 'Online',
'layout.accessRestricted': 'Acesso Restrito',
'layout.featureNotAvailable': 'Funcionalidade não disponível no seu plano',
'layout.currentPlan': 'Plano atual',
'layout.upgradeToUnlock': 'Esta funcionalidade está disponível em planos superiores.',
'layout.contactSupport': 'Entre em contato com o suporte para fazer upgrade do seu plano e desbloquear esta funcionalidade.',
'layout.viewPlans': 'Ver Planos',
  
  // Dashboard
'dashboard.helloOperator': 'Olá, {name}',
'dashboard.operator': 'Atendente',
'dashboard.welcome': 'Bem-vindo ao Dashboard',
'dashboard.operatorSubtitle': 'Acompanhe seu desempenho de atendimento',
'dashboard.subtitle': 'Acompanhe o desempenho da sua empresa em tempo real.',
'dashboard.viewReports': 'Ver Relatórios',
'dashboard.newCampaign': 'Nova Campanha',
'dashboard.errorLoading': 'Erro ao carregar dados',
'dashboard.tryAgain': 'Tentar Novamente',
'dashboard.yourStats': 'Suas Estatísticas',
'dashboard.keepGoodWork': 'Continue o excelente trabalho!',
'dashboard.total': 'Total',
'dashboard.resolved': 'Resolvidas',
'dashboard.avgTime': 'Tempo Médio',
'dashboard.totalConversations': 'Total de Conversas',
'dashboard.activeNow': 'ativas agora',
'dashboard.totalMessages': 'Total de Mensagens',
'dashboard.today': 'hoje',
'dashboard.activeConversations': 'Conversas Ativas',
'dashboard.inProgress': 'Em andamento agora',
'dashboard.avgResponseTime': 'Tempo Médio de Resposta',
'dashboard.conversationsToday': 'conversas hoje',
'dashboard.advancedReports': 'Relatórios Avançados',
'dashboard.detailedMetrics': 'Métricas detalhadas de desempenho',
'dashboard.viewReportsArrow': 'Ver Relatórios →',
'dashboard.leadsCRM': 'CRM de Leads',
'dashboard.manageLeads': 'Gerencie seus leads e oportunidades',
'dashboard.manageLeadsArrow': 'Gerenciar Leads →',
'dashboard.automations': 'Automações',
'dashboard.configureAuto': 'Configure respostas automáticas',
'dashboard.configureArrow': 'Configurar →',
'dashboard.recentConversations': 'Conversas Recentes',
'dashboard.viewAll': 'Ver todas',
'dashboard.contact': 'Contato',
'dashboard.lastMessage': 'Última Mensagem',
'dashboard.dateTime': 'Data/Hora',
'dashboard.status': 'Status',
'dashboard.actions': 'Ações',
'dashboard.loadingConversations': 'Carregando conversas...',
'dashboard.noConversations': 'Nenhuma conversa encontrada.',
'dashboard.user': 'Usuário',
'dashboard.noMessages': 'Sem mensagens',
'dashboard.statusActive': 'Ativa',
'dashboard.statusClosed': 'Fechada',
'dashboard.statusPending': 'Pendente',
'dashboard.openChat': 'Abrir Chat',
  
 // Conversations
'conversations.tabAll': 'Todas',
'conversations.tabOpen': 'Abertas',
'conversations.tabPending': 'Pendentes',
'conversations.tabClosed': 'Resolvido',
'conversations.searchPlaceholder': 'Buscar por nome ou número...',
'conversations.allSectors': 'Todos os Setores',
'conversations.allInSector': 'Todos do Setor',
'conversations.selectSectorFirst': 'Selecione um setor primeiro',
'conversations.allNumbers': 'Todos os Números',
'conversations.noSector': 'Sem setor',
'conversations.noResults': 'Nenhuma conversa encontrada.',
'conversations.clearFilters': 'Limpar filtros',
'conversations.noMessages': 'Sem mensagens',
'conversations.total': 'Total',
'conversations.open': 'Abertas',
'conversations.pending': 'Pendentes',
'conversations.closed': 'Fechadas',
'conversations.selectConversation': 'Selecione uma conversa',
'conversations.chooseToStart': 'Escolha uma conversa para começar',
'conversations.tip': 'Dica',
'conversations.tip1': 'Use os filtros para ver conversas por setor',
'conversations.tip2': 'Selecione um setor para filtrar por atendente',
'conversations.tip3': 'Busque por nome ou número do contato',
  
  // Contatos
'contacts.title': 'Contatos',
'contacts.subtitle': 'Gerencie sua base de contatos',
'contacts.total': 'Total',
'contacts.searchPlaceholder': 'Buscar por nome ou telefone...',
'contacts.all': 'Todos',
'contacts.optInOnly': 'Apenas Opt-in',
'contacts.optOutOnly': 'Apenas Opt-out',
'contacts.selectAtLeastOne': 'Selecione pelo menos um contato',
'contacts.name': 'Nome',
'contacts.notInformed': 'Não informado',
'contacts.phone': 'Telefone',
'contacts.createdIn': 'Criado em',
'contacts.selectedContacts': '{count} contato(s) selecionado(s)',
'contacts.clear': 'Limpar',
'contacts.sendToBulk': 'Enviar para Disparo',
'contacts.contact': 'Contato',
'contacts.createdAt': 'Criado em',
'contacts.actions': 'Ações',
'contacts.loadingContacts': 'Carregando contatos...',
'contacts.noResults': 'Nenhum contato encontrado',
'contacts.tryAdjustFilters': 'Tente ajustar os filtros',
'contacts.contactsWillAppear': 'Os contatos aparecerão aqui',
'contacts.noName': 'Sem nome',
'contacts.viewDetails': 'Ver detalhes',
'contacts.sendToCampaign': 'Enviar para disparo',
'contacts.showing': 'Mostrando',
'contacts.of': 'de',
'contacts.contacts': 'contatos',
'contacts.selectedCount': '{count} selecionado(s)',
  

// Tasks
'tasks.title': 'Tarefas e Follow-up',
'tasks.subtitle': 'Gerencie suas tarefas e acompanhe prazos',
'tasks.newTask': 'Nova Tarefa',
'tasks.priorityLow': 'Baixa',
'tasks.priorityNormal': 'Normal',
'tasks.priorityHigh': 'Alta',
'tasks.priorityUrgent': 'Urgente',
'tasks.errorUpdateStatus': 'Erro ao atualizar status',
'tasks.confirmDelete': 'Excluir tarefa?',
'tasks.errorDelete': 'Erro ao excluir',
'tasks.overdueCount': '{count} tarefa(s) atrasada(s)',
'tasks.dueOn': 'Venceu em',
'tasks.complete': 'Concluir',
'tasks.allTasks': 'Todas as Tarefas',
'tasks.lead': 'Lead',
'tasks.responsible': 'Resp',
'tasks.noTasks': 'Nenhuma tarefa encontrada.',
'tasks.editTask': 'Editar Tarefa',
'tasks.titleField': 'Título',
'tasks.description': 'Descrição',
'tasks.noLinkedLead': 'Sem lead vinculado',
'tasks.noResponsible': 'Sem responsável',


// Chatbots
'chatbots.title': 'Chatbot',
'chatbots.subtitle': 'Automatize o primeiro atendimento com menu de opções',
'chatbots.newChatbot': 'Novo Chatbot',
'chatbots.updated': 'Chatbot atualizado!',
'chatbots.created': 'Chatbot criado!',
'chatbots.errorUpdate': 'Erro ao atualizar',
'chatbots.confirmDelete': 'Excluir este chatbot?',
'chatbots.errorDelete': 'Erro ao excluir',
'chatbots.fillAllOptionFields': 'Preencha todos os campos da opção',
'chatbots.sectorNotFound': 'Setor não encontrado',
'chatbots.totalSessions': 'Total Atendimentos',
'chatbots.completed': 'Completados',
'chatbots.waitingResponse': 'Aguardando Resposta',
'chatbots.sessions': 'atendimentos',
'chatbots.completedLower': 'completados',
'chatbots.welcomeMessage': 'Mensagem inicial',
'chatbots.question': 'Pergunta',
'chatbots.options': 'Opções',
'chatbots.more': 'mais...',
'chatbots.default': 'Padrão',
'chatbots.noChatbots': 'Nenhum chatbot configurado',
'chatbots.createFirst': 'Crie seu primeiro chatbot para automatizar o atendimento',
'chatbots.editChatbot': 'Editar Chatbot',
'chatbots.configureAutoService': 'Configure o atendimento automatizado',
'chatbots.chatbotName': 'Nome do Chatbot',
'chatbots.namePlaceholder': 'Ex: Assistente Virtual',
'chatbots.welcomeMessageLabel': 'Mensagem de Boas-vindas',
'chatbots.welcomePlaceholder': 'Ex: Olá! 👋 Seja bem-vindo(a) à nossa empresa.',
'chatbots.questionLabel': 'Pergunta para o Cliente',
'chatbots.questionPlaceholder': 'Ex: Para te direcionar melhor, escolha uma opção:',
'chatbots.menuOptions': 'Opções do Menu',
'chatbots.menuOptionsHelp': 'Adicione as opções que o cliente pode escolher. Cada opção direciona para um setor.',
'chatbots.addNewOption': 'Adicionar nova opção:',
'chatbots.optionLabelPlaceholder': 'Ex: Agendamento',
'chatbots.selectSector': 'Setor...',
'chatbots.addOption': 'Adicionar Opção',
'chatbots.defaultSectorLabel': 'Setor Padrão (se cliente não escolher opção válida)',
'chatbots.noDefaultSector': 'Nenhum (deixa sem atribuição)',
'chatbots.chatbotActive': 'Chatbot Ativo',
'chatbots.triggerOnNew': 'Acionar em novas conversas',
'chatbots.preview': 'Preview da Mensagem',
'chatbots.typeOptionNumber': 'Digite o número da opção:',
'chatbots.saveChanges': 'Salvar Alterações',
'chatbots.createChatbot': 'Criar Chatbot',

// Funnel
'funnel.title': 'Funil de Vendas',
'funnel.subtitle': 'Visualize e gerencie suas oportunidades',
'funnel.noConversations': 'Nenhuma conversa nesta etapa',
'funnel.noMessages': 'Sem mensagens',
'funnel.high': 'Alta',
'funnel.medium': 'Média',
'funnel.low': 'Baixa',
'funnel.conversationDetails': 'Detalhes da Conversa',


// Leads
'leads.title': 'CRM de Leads',
'leads.subtitle': 'Gerencie seus leads e acompanhe o funil de vendas',
'leads.newLead': 'Novo Lead',
'leads.total': 'Total',
'leads.statusNew': 'Novo',
'leads.statusContacted': 'Contatado',
'leads.statusQualified': 'Qualificado',
'leads.statusConverted': 'Convertido',
'leads.statusLost': 'Perdido',
'leads.sourceManual': 'Manual',
'leads.sourceWebsite': 'Website',
'leads.sourceCampaign': 'Campanha',
'leads.searchPlaceholder': 'Buscar por nome, telefone ou email...',
'leads.allStatuses': 'Todos os status',
'leads.filter': 'Filtrar',
'leads.name': 'Nome',
'leads.contact': 'Contato',
'leads.status': 'Status',
'leads.source': 'Origem',
'leads.responsible': 'Responsável',
'leads.sector': 'Setor',
'leads.actions': 'Ações',
'leads.noResults': 'Nenhum lead encontrado.',
'leads.confirmDelete': 'Tem certeza que deseja excluir este lead?',
'leads.errorDelete': 'Erro ao excluir',
'leads.editLead': 'Editar Lead',
'leads.phone': 'Telefone',
'leads.email': 'Email',
'leads.noResponsible': 'Sem responsável',
'leads.noSector': 'Sem setor',
'leads.lostReason': 'Motivo da perda',

// Team Performance
'teamPerformance.title': 'Desempenho da Equipe',
'teamPerformance.subtitle': 'Acompanhe o desempenho de todos os atendentes',
'teamPerformance.last7days': 'Últimos 7 dias',
'teamPerformance.last30days': 'Últimos 30 dias',
'teamPerformance.last90days': 'Últimos 90 dias',
'teamPerformance.activeAttendants': 'Atendentes ativos',
'teamPerformance.totalConversations': 'Total de conversas',
'teamPerformance.appointments': 'Agendamentos',
'teamPerformance.avgResponseTime': 'Tempo médio resposta',
'teamPerformance.ranking': 'Ranking dos Atendentes',
'teamPerformance.position': 'Posição',
'teamPerformance.attendant': 'Atendente',
'teamPerformance.conversations': 'Conversas',
'teamPerformance.responseTime': 'Tempo Resp.',
'teamPerformance.conversion': 'Conversão',
'teamPerformance.satisfaction': 'Satisfação',
'teamPerformance.noData': 'Nenhum dado disponível',
'teamPerformance.min': 'min',
'teamPerformance.conv': 'conv.',
'teamPerformance.conversionByType': 'Conversão por Tipo de Conversa',
'teamPerformance.conversionRate': 'Taxa de Conversão',

// Appointments
'appointments.title': 'Agendamentos',
'appointments.subtitle': 'Gerencie as consultas e atendimentos',
'appointments.professionals': 'Profissionais',
'appointments.registerProfessionals': 'Cadastrar Profissionais',
'appointments.statistics': 'Estatísticas',
'appointments.sendReminders': 'Enviar Lembretes',
'appointments.newAppointment': 'Novo Agendamento',
'appointments.noSpecialty': 'Sem especialidade',
'appointments.professional': 'PROFISSIONAL',
'appointments.allProfessionals': 'TODOS OS PROFISSIONAIS',
'appointments.fullSchedule': 'Agenda Completa',
'appointments.appointmentsLower': 'agendamentos',
'appointments.confirmedLower': 'confirmados',
'appointments.noShows': 'faltaram',
'appointments.searchPatient': 'Buscar paciente...',
'appointments.all': 'Todos',
'appointments.scheduled': 'Agendado',
'appointments.confirmed': 'Confirmado',
'appointments.completed': 'Concluído',
'appointments.noShow': 'Faltou',
'appointments.cancelled': 'Cancelado',
'appointments.time': 'Horário',
'appointments.patient': 'Paciente',
'appointments.contact': 'Contato',
'appointments.type': 'Tipo',
'appointments.observation': 'Observação',
'appointments.status': 'Status',
'appointments.actions': 'Ações',
'appointments.select': 'Selecione',
'appointments.fullName': 'Nome completo',
'appointments.typeConsultation': 'Consulta',
'appointments.typeReturn': 'Retorno',
'appointments.typeExam': 'Exame',
'appointments.typeProcedure': 'Procedimento',
'appointments.typeUrgency': 'Urgência',
'appointments.typeTreatment': 'Tratamento',
'appointments.typeEvaluation': 'Avaliação',
'appointments.typeTreatment': 'Tratamento',
'appointments.typeEvaluation': 'Avaliação',
'appointments.observationPlaceholder': 'Ex: Trazer exames anteriores...',
'appointments.schedule': 'Agendar',
'appointments.sendReminder': 'Enviar Lembrete',
'appointments.messageToBeSent': 'Mensagem que será enviada',
'appointments.reminderMessage': 'Olá {name}! 👋\nLembramos que você tem uma consulta agendada no dia {date} às {time}.\nPor favor confirme sua presença respondendo esta mensagem. Até lá! 😊',
'appointments.sendVia': 'Enviar via',
'appointments.scheduleStatistics': 'Estatísticas da Agenda',
'appointments.total': 'Total',
'appointments.attendanceRate': 'Taxa Presença',
'appointments.statusDistribution': 'Distribuição de Status',
// Appointments - Mensagens adicionais
'appointments.errorLoading': 'Erro ao carregar agendamentos',
'appointments.statusUpdated': 'Status atualizado para',
'appointments.errorUpdateStatus': 'Erro ao atualizar status',
'appointments.observationSaved': 'Observação salva!',
'appointments.errorSaveObs': 'Erro ao salvar observação',
'appointments.fillRequiredFields': 'Preencha os campos obrigatórios',
'appointments.createdSuccess': 'Agendamento criado com sucesso!',
'appointments.errorCreate': 'Erro ao criar agendamento',
'appointments.confirmDelete': 'Remover este agendamento?',
'appointments.deletedSuccess': 'Agendamento removido',
'appointments.errorDelete': 'Erro ao remover agendamento',
'appointments.reminderSent': 'Lembrete enviado para',
'appointments.errorSendReminder': 'Erro ao enviar lembrete',
'appointments.noPending': 'Nenhum agendamento pendente',
'appointments.confirmSendReminders': 'Enviar lembrete para',
'appointments.remindersSent': 'Lembretes enviados para',
'appointments.patients': 'pacientes',


// BI Integration
'biIntegration.title': 'Integração com BI',
'biIntegration.subtitle': 'Conecte seus dados ao Power BI ou Google Data Studio',
'biIntegration.newIntegration': 'Nova Integração',
'biIntegration.powerBiDescription': 'Conecte-se ao Power BI via webhook para atualizações em tempo real',
'biIntegration.dataStudioDescription': 'Exporte dados em CSV para conectar ao Google Data Studio',
'biIntegration.activeConfig': 'Configuração ativa',
'biIntegration.format': 'Formato',
'biIntegration.autoExport': 'Auto-export',
'biIntegration.frequency': 'Frequência',
'biIntegration.lastExport': 'Última exportação',
'biIntegration.exportNow': 'Exportar Agora',
'biIntegration.exporting': 'Exportando...',
'biIntegration.notConfigured': 'Não configurado',
'biIntegration.configure': 'Configurar',
'biIntegration.viewDocs': 'Ver documentação',
'biIntegration.configureConnection': 'Configure a conexão com sua ferramenta de BI',
'biIntegration.biTool': 'Ferramenta de BI',
'biIntegration.webhookUrl': 'Webhook URL (Power BI)',
'biIntegration.apiKey': 'API Key (opcional)',
'biIntegration.authKey': 'Chave de autenticação',
'biIntegration.exportFormat': 'Formato de Exportação',
'biIntegration.exportFrequency': 'Frequência de Exportação',
'biIntegration.freq_hourly': 'A cada hora',
'biIntegration.freq_daily': 'Diariamente',
'biIntegration.freq_weekly': 'Semanalmente',
'biIntegration.configCreated': 'Configuração criada com sucesso!',
'biIntegration.errorCreate': 'Erro ao criar configuração',
'biIntegration.dataExported': 'Dados exportados para',
'biIntegration.errorExport': 'Erro ao exportar',

// Achievements
'achievements.title': 'Conquistas e Gamificação',
'achievements.subtitle': 'Desbloqueie medalhas e suba no ranking!',
'achievements.medalsWon': 'Medalhas conquistadas',
'achievements.totalPoints': 'Pontos totais',
'achievements.rankingPosition': 'Posição no ranking',
'achievements.topMonth': 'Top 10 do Mês',
'achievements.you': 'você',
'achievements.achievementsLower': 'conquistas',
'achievements.points': 'pontos',
'achievements.pts': 'pts',
'achievements.won': 'Conquistada',
'achievements.locked': 'Bloqueada',
'achievements.categorySpeed': 'Velocidade',
'achievements.categoryVolume': 'Volume',
'achievements.categoryQuality': 'Qualidade',
'achievements.categoryConversion': 'Conversão',

// Users
'users.title': 'Gestão de Usuários',
'users.subtitle': 'Administre perfis, permissões e acessos da equipe.',
'users.newUser': 'Novo Usuário',
'users.limitReached': 'Limite Atingido',
'users.total': 'Total',
'users.active': 'Ativos',
'users.inactive': 'Inativos',
'users.planUsage': 'Uso do Plano',
'users.plan': 'Plano',
'users.userLimitReached': 'Limite de Usuários Atingido',
'users.allowsMax': 'permite no máximo',
'users.usersLower': 'usuários',
'users.contactSupportUpgrade': 'Para adicionar mais usuários, entre em contato com o suporte ou faça upgrade do plano.',
'users.searchPlaceholder': 'Buscar por nome ou email...',
'users.allProfiles': 'Todos os perfis',
'users.roleAdmin': 'Administrador',
'users.roleManager': 'Gerente',
'users.roleAttendant': 'Atendente',
'users.allStatuses': 'Todos os status',
'users.user': 'Usuário',
'users.email': 'Email',
'users.profile': 'Perfil',
'users.sector': 'Setor',
'users.status': 'Status',
'users.actions': 'Ações',
'users.editUser': 'Editar Usuário',
'users.limitReachedModal': 'Limite atingido! Não é possível criar novos usuários.',
'users.userPhoto': 'Foto do Usuário',
'users.fullName': 'Nome completo',
'users.fullNamePlaceholder': 'Ex: João Silva',
'users.emailPlaceholder': 'exemplo@email.com',
'users.newPasswordKeep': 'Nova senha (deixe vazio para manter)',
'users.password': 'Senha',
'users.passwordMinChars': 'Mínimo 6 caracteres',
'users.noSectorLinked': 'Sem setor vinculado',
'users.saveChanges': 'Salvar Alterações',
'users.createUser': 'Criar Usuário',

  // Idiomas
  'language.pt-BR': '🇧🇷 Português',
  'language.en-US': '🇺🇸 English',
  'language.es-ES': '🇪🇸 Español',
  
  // Status
  'status.active': 'Ativo',
  'status.inactive': 'Inativo',
  'status.suspended': 'Suspenso',
  'status.cancelled': 'Cancelado',
  'status.approved': 'Aprovado',
  'status.pending': 'Pendente',
  
  // Roles
  'role.master_admin': 'Master Admin',
  'role.admin': 'Administrador',
  'role.tenant_admin': 'Admin da Empresa',
  'role.manager': 'Gerente',
  'role.attendant': 'Atendente',
  
  // Planos
  'plan.basic': 'Básico',
  'plan.professional': 'Profissional',
  'plan.enterprise': 'Empresarial',
  
  // Master Admin
  'tenants.title': 'Gestão de Empresas',
  'tenants.subtitle': 'Gerencie todas as empresas do sistema',
  'tenants.addNew': 'Adicionar Nova Empresa',
  'tenants.company': 'Empresa',
  'tenants.plan': 'Plano',
  'tenants.status': 'Status',
  'tenants.users': 'Usuários',
  'tenants.actions': 'Ações',
  'tenants.defaultLanguage': 'Idioma Padrão',
  'tenants.defaultLanguageHelp': 'Idioma padrão para novos usuários desta empresa',
  
  // Configurações
  'settings.title': 'Configurações',
  'settings.subtitle': 'Configure sua conta e preferências',
};
